'use client';

import React, { useMemo } from 'react';
import { IconButton2 } from 'components/Button2';
import type { IconButtonProps } from 'components/Button2/IconButton';
import {
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
} from '@frameio/vapor-icons';
import styles from './Carousel.module.css';

export function CarouselArrowButton({
  placement,
  orientation,
  ...other
}: IconButtonProps & {
  placement: 'start' | 'end';
  orientation: 'horizontal' | 'vertical';
}) {
  const icon = useMemo(() => {
    if (orientation === 'horizontal') {
      return placement === 'start' ? <IconChevronLeft /> : <IconChevronRight />;
    }
    if (orientation === 'vertical') {
      return placement === 'start' ? <IconChevronUp /> : <IconChevronDown />;
    }
    throw new Error('Invalid orientation');
  }, [orientation, placement]);

  return (
    <div
      className={styles.arrowPlacement}
      data-orientation={orientation}
      data-position={placement}
    >
      <IconButton2 shape="square" {...other} icon={icon} />
    </div>
  );
}
